import { graphql } from '@apollo/react-hoc';
import { compose } from 'recompose';
import { displayLoadingState } from '../../../utils/displayLoadingState';
import marcasConcorrentesQueryGql from './marcasConcorrentesQuery.graphql';

const hoc = graphql(marcasConcorrentesQueryGql, {
  name: 'marcasConcorrentesQuery',
  options: {
    fetchPolicy: 'cache-first',
  },
});

export const MarcasConcorrentesQueryHOC = compose(
  hoc,
  displayLoadingState({
    name: 'marcasConcorrentesQuery',
    onCacheLoadOnlyQueryName: 'marcasConcorrentes',
  })
);
